import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CommaInput, OrNotSelector } from '.';
import { FlexCol, Label } from '..';
import { FlexRow } from '../FlexRow';
import { MultiListSelector } from './MultiLIstSelector';

export const LocationInfoRow = ({ section, className = '', onChangeItem = () => {} }) => {
  return (
    <FlexRow className={className + ' my-2 items-start'}>
      <FlexRow className="w-1/3 mr-4 items-center">
        {section.labelLink && (
          <a href={section.labelLink} target="_blank" rel="noreferrer" className="text-right w-full font-primary-bold text-primary5">
            {section.label + ' '}
            <FontAwesomeIcon icon={['fas', 'external-link-alt']} className="text-primary5" size="sm" />
            {' :'}
          </a>
        )}
        {!section.labelLink && <Label label={section.label + ':'} className="text-right w-full font-primary-bold" />}
      </FlexRow>
      <FlexCol className="w-3/5">
        {section.items
          .filter((item) => item)
          .map((item, index) => {
            if (
              item.name === 'search_area' ||
              item.name === 'search_zip_code' ||
              item.name === 'search_subdivision' ||
              item.name === 'search_legal_subdivision' ||
              item.name === 'search_street_name'
            ) {
              return <CommaInput key={index} item={item} placeholder="Separate #'s by commas." onChangeItem={onChangeItem} />;
            } else if (item.name === 'search_geo_market_area' || item.name === 'search_city' || item.name === 'search_county') {
              return <MultiListSelector key={index} item={item} onChangeItem={onChangeItem} />;
            } else if (item.name.includes('_condition')) {
              return (
                <FlexRow key={index} className="w-full justify-end">
                  <OrNotSelector key={index} item={item} onChangeItem={onChangeItem} />
                </FlexRow>
              );
            }
          })}
      </FlexCol>
    </FlexRow>
  );
};
